import api, { requestParams } from "@src/api/api";
import { ProductType } from "@src/types/ProductType";

type ProductsResponse = {
  list: ProductType[];
  current_page: number;
  total_pages: number;
};
type ProductsBySellerParams = {
  userId: string;
  xApiClient: string;
  page?: number;
};

export default async function productsBySellerId({
  userId,
  xApiClient,
  page = 0,
}: ProductsBySellerParams): Promise<ProductsResponse> {
  const baseUrl = import.meta.env.VITE_MARKETPLACE_API_URL;
  const { data } = await api.get(
    `${baseUrl}/offer/user/${userId}?${requestParams({ page, perPage: 500, lang: "de", sortBy: "price", order: "ASC" })}`,
    {
      headers: {
        "x-api-client": xApiClient,
      },
    },
  );
  return data;
}
